export const ROLES = {
  ADMIN: "admin",
  TRAINER: "trainer",
  MEMBER: "member",
  RECEPTIONIST: "receptionist",
};

export const ROLE = {
  1: "admin",
  2: "trainer",
  3: "member",
  4: "receptionist"
};
